import apiUrl from '../../constants';
import axios from 'axios';


export function BucketList( token){
            let inputPayload = {
                isactive:true
            }
             return axios({
                method: 'post',
                url: apiUrl.api_url + 'fetchb2bBucket',
                data: inputPayload,
                headers: {
                  'Authorization': 'Bearer ' + token
                }
              }) 
            }
        


// WEBPACK FOOTER //
// ./src/services/B2BModule/B2BGetbucktApi.js